import { APP_URL } from 'types';
interface Param {
  name: string;
  value: string;
}

class UrlBuilder {
  base: string = '';
  parameters: any = [];

  addParameter(name: string, value: string | number | boolean): this {
    if (value !== undefined) {
      this.parameters.push({ name, value });
    }
    return this;
  }

  toString = () => {
    if (this.parameters.length > 0) {
      return `${this.base}?${this.parameters
        .map(({ name, value }: Param) => `${name}=${encodeURIComponent(value)}`)
        .join('&')}`;
    } else {
      return this.base;
    }
  };

  constructor(baseUrl: string) {
    this.base = baseUrl;
    this.parameters = [];
  }
}

const createUrlBuilder = (baseUrl: string) => new UrlBuilder(baseUrl);
// AZURE SSO REDIRECT URLS
export const DEFAULT_LOGIN_URL = `${window.location.origin}${APP_URL.LOGIN}`;
export const SSO_LOGIN_REDIRECT_URL = `${window.location.origin}${APP_URL.AUTH}`;
export const SSO_LOGOUT_REDIRECT_URL = `${process.env.REACT_APP_DBYD_IDP_LOGOUT}?post_logout_redirect_uri=https%3A%2F%2F${process.env.REACT_APP_COGNITO_DOMAIN}%2Flogout%3Fclient_id%3D${process.env.REACT_APP_COGNITO_APP_CLIENT_ID}%26logout_uri%3D${SSO_LOGIN_REDIRECT_URL}`;

export default createUrlBuilder;
